import axios from '../axios';
export const save = data => {
  // 增
  if (!data.userId) {
    return axios({
      url: '/api/sys/user/saveSysUser',
      method: 'post',
      data
    })
  } else {
    // 改
    return axios({
      url: '/api/sys/user/updateSysUser',
      method: 'post',
      data
    })
  }
}
// 删除
export const deleteSysUsers = data => {
  return axios({
    url: '/api/sys/user/deleteSysUsers',
    method: 'post',
    data
  })
};
// 查列表
export const getSysRolePage = data => {
  return axios({
    url: '/api/sys/user/getSysUserPage',
    method: 'post',
    data
  })
};

//根据用户id查询该用户的的权限列表
export const userMenu = data => {
  return axios({
    url: '/api/sys/user/queryUserMenuByUserId',
    method: 'post',
    data
  })
};
export const edit = data => {
  return axios({
    url: 'api/base/user_menu/edit',
    method: 'post',
    data
  })
};
//改密码
export const userSelf = data => {
  return axios({
    url: '/api/base/user/update_self',
    method: 'post',
    data
  })
};
//初始化密码
export const resetPasswordWx = data => {
  return axios({
    url: '/api/sys/wxuser/resetPassword',
    method: 'post',
    data
  })
};
//通过手机号查询微信用户
export const getSysWxUserByPhone = data => {
  return axios({
    url: '/api/sys/wxuser/getSysWxUserByPhone',
    method: 'post',
    data
  })
};
//根据用户id查询该用户的角色列表树
export const userMenuTreeByUserId = data => {
  return axios({
    url: '/api/sys/user/userMenuTreeByUserId',
    method: 'post',
    data
  })
};
//根据用户id查询该用户的权限id数组
export const userMenuTreeByUserIdArray = data => {
  return axios({
    url: '/api/sys/user/userMenuTreeByUserIdArray',
    method: 'post',
    data
  })
};
//给用户添加权限
export const userBindingMeun = data => {
  return axios({
    url: '/api/sys/user/userBindingMeun',
    method: 'post',
    data
  })
};
//修改登录用户密码
export const password = data => {
  return axios({
    url: '/api/sys/user/password',
    method: 'post',
    data
  })
};
//重置密码
export const resetPassword = data => {
  return axios({
    url: '/api/sys/user/resetPassword',
    method: 'post',
    data
  })
};
//根据用户id查询该用户的装卸地
export const getUserLoadByUserId = data => {
  return axios({
    url: '/api/sys/user/getUserLoadByUserId',
    method: 'post',
    data
  })
};
//根据用户id查询该用户的仓库
export const getUserStockByUserId = data => {
  return axios({
    url: '/api/sys/user/getUserStockByUserId',
    method: 'post',
    data
  })
};
//用户绑定装卸地
export const userLoadBinding = data => {
  return axios({
    url: '/api/sys/user/userLoadBinding',
    method: 'post',
    data
  })
};
//用户组织分配
export const authTissueData = data => {
  return axios({
    url: '/api/sys/user/authTissueData',
    method: 'post',
    data
  })
};
//用户的组织
export const getUserTissueList = data => {
  return axios({
    url: '/api/sys/getUserTissueList',
    method: 'post',
    data
  })
};
//App菜单
export const appList = data => {
  return axios({
    url: '/api/sys/menu/appList',
    method: 'post',
    data
  })
};
//微信用户表列表
export const getSysWxUserPage = data => {
  return axios({
    url: '/api/sys/wxuser/getSysWxUserPage',
    method: 'post',
    data
  })
};
//微信用户表列表删除
export const deleteSysWxUsers = data => {
  return axios({
    url: '/api/sys/wxuser/deleteSysWxUsers',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/user.js